import React from "react";
import AutocompleteInput from "components/FormElements/AutocompleteInput";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as tagTransformer } from "schemas/Tag";

export default function TagField(props) {
    const auth = useAuth();

    return (
        <AutocompleteInput
            label="Tags"
            name={props.name}
            onRequestSearch={async (term) => {
                const items = await apiGet("/v4/search", auth.publication, {
                    keyword: term,
                    per_page: 5,
                    type: "tag",
                });

                return tagTransformer(items).map((item) => {
                    return {
                        label: item.name,
                        value: item.uuid,
                    };
                });
            }}
        />
    );
}
